import { HowToFileClaimSection } from './view';
export default HowToFileClaimSection;
